var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e-textarea"},[_c('RichContent',{attrs:{"content":_vm.data.content.html}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }